var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 1,
    viewBox: "0 0 354 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 354,
    y2: 0.5,
    stroke: "#0C1331",
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.ce87196bd093979384dc15a3ce0c2a4a.svg";
export { ForwardRef as ReactComponent };